
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/23f08ced14bf4a36e142d1d997067ecc.jpg"
          alt="Data Center Infrastructure"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-950/70 via-slate-900/60 to-blue-950/70"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Fabricamos Energía Crítica<br />para Infraestructura Global
        </h1>
        <p className="text-xl md:text-2xl text-blue-100 mb-12 max-w-4xl mx-auto leading-relaxed">
          Soluciones certificadas CE en UPS, rectificadores e integración de almacenamiento energético para centros de datos, telecom e industria
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={scrollToContact}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            Solicitar Cotización
          </button>
          <button 
            onClick={scrollToContact}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap"
          >
            Contactar Ingeniería
          </button>
        </div>
      </div>
    </section>
  );
}
